import { memo, useCallback } from 'react'
import { useIntl } from 'react-intl'
import FilterChip from 'LuxKit/Chips/FilterChip'
import type { ChatExploreCategory } from 'tripPlanner/config/exploreCategories'

interface Props {
  category: ChatExploreCategory
  isSelected: boolean
  isDisabled?: boolean
  onSelect: (category: ChatExploreCategory) => void
}

function ExploreCategoryChip({ category, isSelected, isDisabled, onSelect }: Props) {
  const intl = useIntl()
  const { labelMessage, icon: Icon } = category

  const handleClick = useCallback(() => {
    onSelect(category)
  }, [category, onSelect])

  return (
    <FilterChip
      selected={isSelected}
      aria-pressed={isSelected}
      disabled={isDisabled}
      size="medium"
      startIcon={<Icon />}
      onClick={handleClick}
    >
      {intl.formatMessage(labelMessage)}
    </FilterChip>
  )
}

export default memo(ExploreCategoryChip)
